global.$ = global.jQuery = require('jquery');

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import Headroom from "headroom.js";

import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
window.Swiper = Swiper;

import AOS from 'aos';
import 'aos/dist/aos.css';


$(document).ready(function() {

    if($('.headroom').length > 0){
        let headroomEl = document.querySelector("header");
        let headroom  = new Headroom(headroomEl);
        headroom.init();
    }

    // To-top button
    const toTopBtn = $('#to-top');
    $(window).scroll(function(){
        if ($(window).scrollTop() > 300) {
            toTopBtn.fadeIn();
        } else {
            toTopBtn.fadeOut();
        }
    });

    toTopBtn.on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, 'slow');
    });

    let linkServizi = $('.link-servizi');
    let desktopServizi = $('.sub-menu-services');

    linkServizi.on({
        mouseenter: function () {
            if (!linkServizi.hasClass('opened')){
                linkServizi.addClass('opened')
                desktopServizi.stop().slideDown('fast');
            }
        },
        mouseleave: function () {
            if (linkServizi.hasClass('opened')){
                linkServizi.removeClass('opened')
                desktopServizi.stop().slideUp('fast');
            }
        }
    });

    const arrowMenu = $('.bi-arrow-left');
    arrowMenu.on('click', function (){

    });

    let burgerButton = $('.burger-button');
    let mainMenu = $('.sub-menu-general')
    let btx = $('.bi-x')
    let btmenu = $('.bi-list')
    burgerButton.on( "click", function(event) {
        event.preventDefault()
        if (!burgerButton.hasClass('opened')){
            btx.removeClass('d-none')
            btmenu.addClass('d-none')
            burgerButton.addClass('opened')
            event.preventDefault()
            mainMenu.stop().slideDown('fast');
            $('body').addClass('overflow-hidden')
            event.stopPropagation()
        } else {
            event.preventDefault()
            btx.addClass('d-none')
            btmenu.removeClass('d-none')
            burgerButton.removeClass('opened')
            event.preventDefault()
            mainMenu.stop().slideUp('fast');
            $('body').removeClass('overflow-hidden')
            event.stopPropagation()
        }
    });

    let linkServiziMobile = $('.link-servizi-mobile')
    let mobileServizi = $('.sub-menu-services-mobile')
    linkServiziMobile.on( "click", function(event) {
        event.preventDefault()
        if (!linkServiziMobile.hasClass('opened')){
            event.preventDefault()
            linkServiziMobile.addClass('opened')
            mobileServizi.stop().slideDown('fast');
            linkServiziMobile.addClass('rotate-180')
            event.stopPropagation()
        } else {
            event.preventDefault()
            linkServiziMobile.removeClass('opened')
            mobileServizi.stop().slideUp('fast');
            linkServiziMobile.removeClass('rotate-180')
            event.stopPropagation()
        }
    });

});
